import { ProductPlatform } from "client/api-v2";

// "Self-Hosted" is what staff call OctopusServer everywhere in the portal — the enum name is never shown.
// Platform is optional on some subscription DTOs and the detail page substitutes "Unknown" for a missing
// one, so anything off the contract is handed back untouched rather than labelled as a platform it isn't.
export function formatPlatform(platform: ProductPlatform | string | undefined): string {
  switch (platform) {
    case ProductPlatform.OctopusCloud:
      return "Cloud";
    case ProductPlatform.OctopusServer:
      return "Self-Hosted";
    default:
      return platform ?? "";
  }
}
